import ApplicationController from '../application_controller'
import { put } from '@rails/request.js'

class ObjectiveActionsController extends ApplicationController {
  connect () {
    this.finishClickHandler = this.finishClickHandler || this.onFinishClick.bind(this)
    this.finishElements = this.element.querySelectorAll('[data-finish="true"]')

    this.finishElements.forEach(element => {
      element.addEventListener('click', this.finishClickHandler)
    })
  }

  disconnect () {
    if (!this.finishElements || !this.finishClickHandler) return

    this.finishElements.forEach(element => {
      element.removeEventListener('click', this.finishClickHandler)
    })
  }

  onFinishClick (event) {
    event.preventDefault()

    const url = event.currentTarget.dataset.url
    if (!url) return

    put(url, {
      body: { boarding_objective_action: { finished: true } },
      responseKind: 'turbo-stream'
    })
  }
}

export default ObjectiveActionsController
